import BlockComponentButton from '../../../models/BlockComponentValues/BlockComponentButton';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

class BlockButtonData {
  button: BlockComponentButton;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockButtonData {
  export function make(button?: BlockComponentButton, url?: string): BlockButtonData {
    return {
      button: BlockComponentButton.make(button.link, button.settings),
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(): BlockButtonData {
    return make(
      BlockComponentButton.getDefault(),
    );
  }
}

export default BlockButtonData;
